<div class="d-inline-block w-100 h-100k" >
    <canvas [id]="'stackedBarChart_' + indexId" width="400" height="400"></canvas>

  </div>